import { memo } from "react";

import { type CloudFlowNodeType } from "@doitintl/cmp-models";

import { type RFNode } from "../../types";
import { SourceHandle } from "./Handle";
import { RoundedNodeIcon } from "./NodeIcon";
import NodeWrapper from "./NodeWrapper";

type Props = {
  id: string;
  data: RFNode<CloudFlowNodeType.WEBHOOK_TRIGGER>;
  selected?: boolean;
};

const InternalWebhookNode = ({ id, data, selected }: Props) => {
  const title = "Webhook";
  return (
    <>
      <NodeWrapper
        title={title}
        errorMessages={data.nodeData.errorMessages || {}}
        status={data.nodeData.status || "validated"}
        onEdit={data.onEditNode}
        isActive={!!selected}
        name={`${data.stepNumber}. ${data.nodeData.name}`}
        icon={<RoundedNodeIcon node={data} />}
      />
      <SourceHandle id={id} />
    </>
  );
};

export const WebhookNode = memo(InternalWebhookNode);
